import ajax from '../assets/js/axios.config';

//统计方法
//101.71.99.249:6080/@/ui/lists/getListElements/6.0.0/1234?listName=新闻推荐专题列表&pageIndex=0&pageSize=20

//101.71.99.249:6080/@/ui/lists/getListElements/6.0.0/1234?listName=新闻推荐专题新闻列表&pageIndex=0&pageSize=20&ContentUrl=http://101.71.99.249:6082/postSet.html?postSetName=新闻推荐专题%26postSetId=21
export function statistics(specialName) {
    let flag = 0;
    let timer = setInterval(() => {
        let aTag = document.createElement("a");
        if (ajax.getQueryString("InGSApp")) {
            if (ajax.isAndroid()) {
                aTag.href =
                    'GSApp://open.app?{"contentType":"uMeng", "content":"games_all_gamepage_time", "contentParam":"' +
                    specialName +
                    "," +
                    flag +
                    "s" +
                    '"}';
            } else {
                aTag.href =
                    'GSApp://open.app?{"contentType":"uMeng", "content":"games_all_gamepage_t", "contentParam":"' +
                    specialName +
                    "," +
                    flag +
                    "s" +
                    '"}';
            }
            aTag.click();
        }
        flag = flag + 1;
        //console.log(aTag,specialName,flag)
    }, 1000);
}

//根据listName 获取数据
export function topicHomePage(request) {
    var appVersion = "6.0.0"
    var clientName = "Web";
    var userAgent = window.navigator.userAgent;
    if (userAgent != null
        && userAgent.length > 0)
    {
        if (userAgent.indexOf("iOS") >= 0) {
            clientName = "App_iOS";
        } else if (userAgent.indexOf("Android") >= 0) {
            clientName = "App_Android";
        }

        var gsApp = "GSApp/";
        var indexOfGSApp = userAgent.indexOf(gsApp);
        if (indexOfGSApp >= 0)
        {
            var indexOfBlank
                    = userAgent.indexOf(
                            " ",
                    indexOfGSApp + gsApp.length);
            if (indexOfBlank > indexOfGSApp){
                //
                appVersion = userAgent.substring(
                        indexOfGSApp + gsApp.length,
                        indexOfBlank);
                //
            }
        }
    }
    return ajax
        .get(
            `@/topicHomePage/index/${appVersion}/${GSAppJsApi.User.getCurrentUserId()}/${clientName}`, request
        )
}
export function topicPage(request) {
    let apiUrl = "";
    apiUrl = `@/topicPage/index/6.0.0/${GSAppJsApi.User.getCurrentUserId()}`;
    return ajax
        .get(
            apiUrl, request
        )
}

export function labelGame(request) {
    return new Promise((resolve, reject) => {
        if (GSAppJsApi.User.getCurrentUserId() != 0) {
            let _currentGameId = GSAppJsApi.User.getCurrentUserId();
            let apiUrl = `//router.gamersky.com/@/userData/labelGame/6.0.0/${_currentGameId}?gameId=${request.GameId}&labelType=xiangWan`;
            GSAppJsApi.Net.get(
                apiUrl,
                function (response) {
                    if (response != null
                        && (response.error == null
                            || response.error.length < 1)) {
                        console.log("关注成功");
                        resolve(response);
                    }
                    else {
                        console.log("关注游戏（" + _currentGameId + "）失败，失败原因：" + response.error + "。");
                        reject(response);
                    }
                });
        } else {
            resolve({ error: "您还未登录" });
        }
    });
}

export function cancelLabelGame(request) {
    return new Promise((resolve, reject) => {
        if (GSAppJsApi.User.getCurrentUserId() != 0) {
            let _currentGameId = GSAppJsApi.User.getCurrentUserId();
            let apiUrl = `//router.gamersky.com/@/userData/cancelLabelGame/6.0.0/${_currentGameId}?gameId=${request.GameId}&labelType=xiangWan`;
            GSAppJsApi.Net.get(
                apiUrl,
                function (response) {
                    if (response != null
                        && (response.error == null
                            || response.error.length < 1)) {
                        console.log("关注成功");
                        resolve(response);
                    }
                    else {
                        console.log("关注游戏（" + _currentGameId + "）失败，失败原因：" + response.error + "。");
                        reject(response);
                    }
                });
        } else {
            resolve({ error: "您还未登录" });
        }
    });
}


// 获取头图
export function getTopBanner(listName) {
    return ajax
        .get(
            "@/ui/postSets/getPostSet", listName
        )
}


//绑定Epic账号
export function bindEpic(request) {
    return new Promise((resolve, reject) => {
        if (GSAppJsApi.User.getCurrentUserId() != 0) {

            let currentUserId = GSAppJsApi.User.getCurrentUserId();
            // _currentGameId = 2516504 //*测试
            let apiUrl = `https://router.gamersky.com/@/user/getUser/6.0.0/0?objectUserId=${currentUserId}`;
            ajax.get(apiUrl)
                .then(({user:{epicAccount}})=>{
                    resolve({error:epicAccount? '您已绑定EPIC账号':''})
                })
                .catch(()=>{
                    resolve({ error: "服务器异常" });
                })
        } else {
            resolve({ error: "您还未登录" });
        }
    });
}

//CMS统计
export function CMSStatistics(id) {

    ajax.jsonp('//click.gamersky.com/Common/GetHits.aspx',{
        id,
        script: 3
    }).then(()=>{}).catch(()=>{})
}